import { Anchor, Group, Stack } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { DynamicDashboard } from "../components/dashboard/DynamicDashboard";
import { KycStatusCallout } from "../components/KycStatusCallout";
import { PageHeader } from "../components/ui";
import { useAuth } from "../context/useAuth";
import { recruiterApi } from "../lib/api";
import { NAV_ICONS } from "../lib/navCopy";

export function DashboardPage() {
  const { user } = useAuth();

  const profileQuery = useQuery({ queryKey: ["my-profile"], queryFn: recruiterApi.myProfile });

  const profile = profileQuery.data;

  return (
    <Stack gap="var(--axio-unit-32)">
      <PageHeader
        icon={NAV_ICONS.dashboard}
        title={`Welcome back, ${user?.full_name?.split(" ")[0] ?? ""}`}
        subtitle="Here's how your pipeline is doing."
      />

      <KycStatusCallout profile={profile} />

      <DynamicDashboard />

      <Group gap="sm">
        {!profile?.consultancy_id && (
          <Anchor component={Link} to="/payments" className="quickLinkChip">
            <NAV_ICONS.payments size="var(--axio-unit-16)" />
            View all payments & earnings
          </Anchor>
        )}
        <Anchor component={Link} to="/candidates" className="quickLinkChip">
          Manage candidates
        </Anchor>
      </Group>
    </Stack>
  );
}
